import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private refreshSubject = new Subject<void>();

  refresh$ = this.refreshSubject.asObservable();

  refreshBreadcrumbs(): void {
    this.refreshSubject.next();
  }
}
